import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["color"];
import React, { memo } from 'react';
const SalesOrdersIcon = _ref => {
  let {
      color = '#335B70'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M9.6 25.6c-1.76 0-3.184 1.44-3.184 3.2s1.424 3.2 3.184 3.2c1.76 0 3.2-1.44 3.2-3.2s-1.44-3.2-3.2-3.2zM0.001 0v3.2h3.2l5.76 12.144-2.16 3.92c-0.256 0.448-0.4 0.976-0.4 1.536 0 1.76 1.44 3.2 3.2 3.2h19.2v-3.2h-18.528c-0.224 0-0.4-0.176-0.4-0.4l0.048-0.192 1.44-2.608h11.92c1.2 0 2.256-0.656 2.8-1.648l5.728-10.384c0.128-0.224 0.192-0.496 0.192-0.768 0-0.88-0.72-1.6-1.6-1.6h-23.663l-1.504-3.2h-5.232zM25.6 25.6c-1.76 0-3.184 1.44-3.184 3.2s1.424 3.2 3.184 3.2c1.76 0 3.2-1.44 3.2-3.2s-1.44-3.2-3.2-3.2z"
  }));
};
export default /*#__PURE__*/memo(SalesOrdersIcon);